import styled from "styled-components";
import { colors } from "../../utils";
import { device } from "../../utils/device";
import { motion } from "framer-motion";

export const Container = styled.div`
  min-width: 180px;
  width: 30vw;
  max-width: 320px;

  @media (${device.mobilePortrait}) {
    min-width: 10px;
    width: 100%;
  }

  @media (${device.mobileLandscape}) {
    flex-grow: 1;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${colors.white};
  border: 1px solid #ced4da;
  padding: 5px 10px;
  border-radius: 8px;
  height: 5vh;
  align-items: center;
  position: relative;

  @media (${device.mobileLandscape}) {
    height: 40px;
    border-radius: 4px;
  }
`;
export const SearchIcon = styled(motion.img)`
  position: absolute; /* Absolute positioning */
  left: 10px; /* Adjust based on your padding */
  top: 25%;
  transform: translateY(-50%);
  width: 20px; /* Set desired size */
  height: 20px;
  object-fit: contain; /* Ensures the icon scales correctly */
  object-position: center;
  display: block; /* Removes any extra space below the image */
`;

export const ClearIcon = styled(motion.img)`
  cursor: pointer;
  position: absolute;
  right: 10px; /* Space from the right edge */
  top: 25%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  object-fit: contain;
  object-position: center;
  display: block;
`;

export const TextInput = styled.input`
  outline: none;
  border: none;
  width: 100%;
  padding-left: 30px;

  &::placeholder {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    font-family: "DM Sans", sans-serif;
    color: #212529;
  }
`;

export const ResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 30vw;
  background-color: ${colors.white};
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  border-radius: 8px;
  // overflow-y: auto;
  // overflow-x: hidden;
  overflow: hidden;
  z-index: 10000;
  padding-left: 20px;
  padding-right: 10px;
  max-height: 405px;
  padding-bottom: 5px;

  @media (${device.mobilePortrait}) {
    width: 100vw;
    height: 100vh;
    left: 0;
    border-radius: 0;
  }

  @media (${device.mobileLandscape}) {
    width: 100vw;
    left: 0;
    border-radius: 0;
    top: 60px;
    padding-left: 60px;
  }
`;

export const TabsContainer = styled.div`
  position: sticky;
  top: 0;
  background-color: ${colors.white};
  z-index: 1001; /* Ensure it stays above the scrollable content */
`;

export const ItemsContainer = styled.div`
  flex: 1; /* Take up remaining space */
  overflow-y: auto; /* Enable vertical scrolling */
  padding-right: 10px; /* Optional: To match padding in ResultsContainer */
  padding-left: 5px;

  scroll-behavior: smooth; /* Smooth scrolling experience */
`;

export const InfiniteLoader = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;
`;

export const ResultType = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
`;

export const BottomView = styled.div`
  padding: 10px;
  border-top: 1px solid ${colors.lightGrey};
  margin-top: 10px;
  &:hover {
    background-color: #f0f0f0;
    cursor: pointer;
  }

  @media (${device.mobileLandscape}) {
    display: none;
  }

  @media (${device.mobilePortrait}) {
    display: none;
  }
`;

export const SearchItem = styled(motion.div)`
  padding: 10px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s ease;
`;

export const Loader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
`;
